import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars, faBagShopping, faClose, faGift, faBox, faSms, faSection, faPhone, faEnvelope, faHandshake, faTruck } from '@fortawesome/free-solid-svg-icons'
import { faInstagram, faFacebook, faTiktok, faWhatsapp } from '@fortawesome/free-brands-svg-icons'

import Logo from '../images/negativ-logo-circle-transparent.webp';
import Logo2 from '../images/negativ-main-logo.webp';
import LangButton from '../components/langbutton';
import MenuLinks from "./menulinks";

import useDictionary from '../hooks/useDictionary';

import '../css/navbar.css';
import '../css/sidemenu.css';

function useBreakpoint() {
  const getBreakpoint = () => {
    if (window.matchMedia("(max-width: 575px)").matches) return "mobile";
    if (window.matchMedia("(max-width: 991px)").matches) return "tablet";
    return "desktop";
  };

  const [breakpoint, setBreakpoint] = useState(getBreakpoint);

  useEffect(() => {
    const handler = () => setBreakpoint(getBreakpoint());
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);

  return breakpoint;
}

export default function NavBar({
  collection  = 'Nobody does it better — Kolekcja SS 2026',
  brandName   = 'NEGATIV',
  tagline     = 'Manufaktura Premium',
  since       = 'Polska produkcja od 2007 roku',
  year        = '2007',
  cornerLabel = 'Brand NGV®',
}) {
    
    const [utilityBarVisible, setUtilityBarVisible] = useState(true);
    const breakpoint = useBreakpoint();

    useEffect(() => {

        const navpanel = document.getElementById('navigation-bar-container');
        const logo = document.getElementById('small-menu-logo');

        const handleScroll = () => {

            if (window.scrollY > 480) {
                
                setUtilityBarVisible(false);

                if (breakpoint === 'desktop') {

                    setTimeout(() => {
                        navpanel.style.justifyContent = 'space-between';
                        navpanel.style.paddingLeft = "20px";
                        navpanel.style.paddingRight = "30px";
                        logo.style.display = 'block';
                    }, 500);

                }
                
            } else {

                setUtilityBarVisible(true);
                
                if (breakpoint === 'desktop') {

                    setTimeout(() => {
                        navpanel.style.justifyContent = 'center';
                        navpanel.style.paddingLeft = 0;
                        navpanel.style.paddingRight = 0;
                        logo.style.display = 'none';
                    }, 500);

                }

            }
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };

    }, [breakpoint]);

    const params = useParams();
    const dictionary = useDictionary();

    const [sideBarVisible, setSideBarVisible] = useState(false);

    const toggleSideBar = () => {
        setSideBarVisible(prev => !prev);
    }

    return (
        <>

        <div className={`overlay ${ sideBarVisible ? 'overlay-visible' : 'overlay-hidden' }`} id="overlay" onClick={() => {setSideBarVisible(false)}}></div>

        <nav className={`side-menu ${sideBarVisible ? 'side-menu-visible' : 'side-menu-hidden'}`} id="sideMenu">
            
            <div className="close-button" onClick={() => {setSideBarVisible(false)}}><FontAwesomeIcon icon={faClose} /></div>

            <div className="logo"><img alt="Negativ Brand Logo" src={Logo2} /></div>
            
            <ul>
                <li className="elements-to-collapse"><a href={`https://store.negativbrand.com/${params.lang}/mainpage/`} title="Sklep internetowy"><FontAwesomeIcon icon={faBagShopping} className="side-menu-icon" /> Sklep online</a></li>
                <li className="elements-to-collapse"><a href={`https://store.negativbrand.com/${params.lang}/giftcards/`} title="Karty podarunkowe"><FontAwesomeIcon icon={faGift} className="side-menu-icon" /> Karty podarunkowe</a></li>
                <li className="elements-to-collapse"><a href={`https://store.negativbrand.com/${params.lang}/sms/`} title="Serwis SMS"><FontAwesomeIcon icon={faSms} className="side-menu-icon" /> Serwis SMS</a></li>
                <li className="elements-to-collapse"><a href={`https://store.negativbrand.com/${params.lang}/returns/`} title="Zwroty i wymiany"><FontAwesomeIcon icon={faBox} className="side-menu-icon" /> Zwroty i wymiany</a></li>
                <li><a href="tel:48792707070" title="Zadzwoń do nas!"><FontAwesomeIcon icon={faPhone} className="side-menu-icon" /> Zadzwoń do nas!</a></li>
                <li><a href={`https://store.negativbrand.com/${params.lang}/read/contact.html`} title={dictionary.CONTACT}><FontAwesomeIcon icon={faEnvelope} className="side-menu-icon" /> {dictionary.CONTACT}</a></li>
                <li className="elements-to-collapse"><a href={`https://b2b.negativbrand.com/${params.lang}/`} title="B2B Platform"><FontAwesomeIcon icon={faHandshake} className="side-menu-icon" /> B2B</a></li>
                <li className="elements-to-collapse"><a href={`https://store.negativbrand.com/${params.lang}/read/delivery_services.html`} title="Informacje o dostawie"><FontAwesomeIcon icon={faTruck} className="side-menu-icon" /> Informacje o dostawie</a></li>
                <li className="elements-to-collapse"><a href={`https://store.negativbrand.com/${params.lang}/read/terms_and_conditions.html`} title="Regulamin i zasady"><FontAwesomeIcon icon={faSection} className="side-menu-icon" /> Regulamin i zasady</a></li>
            </ul>

            <div className="hotline">
                <div className="text">{dictionary.DO_YOU_HAVE_QUESTION}</div>
                <div className="numbers">
                    <a href="tel:+48222442245"><FontAwesomeIcon icon={faPhone} className="icon" /> 222 44 22 45</a>
                    <a href="tel:+48792707070"><FontAwesomeIcon icon={faSms} className="icon" /> <FontAwesomeIcon icon={faWhatsapp} className="icon" /> 792 70 70 70</a>
                </div>
                <div className="text">{dictionary.HOT_LINE_WORK_HOURS}<br />{dictionary.FROM} <span>9:00</span> {dictionary.TO} <span>16:00</span></div>
            </div>

            <div className="pusher"></div>

        </nav>

        <div className={`main-menu ${utilityBarVisible ? 'main-menu-visible' : 'main-menu-hidden'}`}>
            
            <div className="utility-bar">
                <div className="social-media">
                    <a href="https://www.facebook.com/NegativFashion/"><FontAwesomeIcon icon={faFacebook} style={{ fontSize: '25px', color: '#66E'  }} /></a>
                    <a href="https://www.instagram.com/negativ_official/"><FontAwesomeIcon icon={faInstagram} style={{ fontSize: '25px', color: '#FF0069' }} /></a>
                    <a href="https://www.tiktok.com/@negativofficial/"><FontAwesomeIcon icon={faTiktok} style={{ fontSize: '24px', color: '#FFF' }} /></a>
                    <a href="https://wa.me/48792707070/" target="_whatsapp"><FontAwesomeIcon icon={faWhatsapp} style={{ fontSize: '24px', color: '#3E3' }} /></a>
                </div>
                <div className="lang-switches">
                    { params.lang && params.lang === 'pl' ? <LangButton lang="en" flag="GB" title="English" /> : <LangButton lang="pl" flag="PL" title="Polski" /> }
                </div>
            </div>

            <nav className="navigation-bar">

                <div className="mobile-navbar hide-on-768">
                    <button className="action-button flex-off-768" onClick={toggleSideBar}><FontAwesomeIcon icon={faBars} /> MENU</button>
                    <a className="action-button" href={`https://store.negativbrand.com/${params.lang ? params.lang : 'pl'}`}><FontAwesomeIcon icon={faBagShopping} /> {dictionary.ONLINE_STORE_BUTTON}</a>
                </div>

                <div className="small-header">
                    {dictionary.PREMIUM_BRAND_LABEL}
                </div>

                <div className="navigation-bar-logo logo-part-1">
                    <img src={Logo} alt="test" style={{width: '60%', maxWidth: '270px'}} />
                </div>

                <div className="navigation-bar-logo logo-part-2" style={{marginTop: '20px'}}>
                    <img src={Logo2} alt="test" />
                </div>

                <div className="navigation-bar-container" id="navigation-bar-container">

                    <img src={Logo2} alt="test" className="small-menu-logo" id="small-menu-logo" />

                    <ul id="menu-nav-links">
                        <MenuLinks />
                    </ul>

                    <a className="action-button" href={`/${params.lang ? params.lang + '/store' : 'pl/store'}`}><FontAwesomeIcon icon={faBagShopping} /> {dictionary.ONLINE_STORE_BUTTON}</a>

                </div>
            
            </nav>

        </div>
        </>
    )
}